// extracted by mini-css-extract-plugin
export default {"wrap":"InfoFieldValueCouple_wrap__GzLYD","withLine":"InfoFieldValueCouple_withLine__3EuYQ"};